import { Articles } from "@tm/data"
import { Article, Vehicle } from "@tm/models"
import { uniqBy } from "lodash"
import { SetterOrUpdater } from "recoil"
import { isSameArticle } from "@tm/utils"
import { PartItem } from "../../../../../../../basket/src/data/model"

export function createRecommendedArticlesRequest(
    parts: PartItem[] | undefined,
    articles: Article[],
    workTaskId: string,
    setCustomerAlsoBoughtProductGroupsState: SetterOrUpdater<Article[][]>,
    setRecommendedArticlesChain: SetterOrUpdater<Article[][]>,
    setCustomerAlsoBoughtArticlesChain: SetterOrUpdater<Article[][]>,
    refArticle?: Article,
    vehicle?: Vehicle
): Articles.GetRecommendedArticlesRequest | undefined {
    const basketArticles = parts?.filter((item) => item.vehicleId === vehicle?.id) ?? []

    let recommendedArticlesIn: Articles.RecommendedArticleIn[] = []

    basketArticles.forEach((basketArticle) => {
        if (basketArticle.articleInformation.articleNumber && basketArticle.articleInformation.supplierId) {
            recommendedArticlesIn.push({
                supplierArticleNo: basketArticle.articleInformation.articleNumber,
                supplierId: basketArticle.articleInformation.supplierId,
                productGroupId: basketArticle.articleInformation.productGroupId,
            })
        }
    })

    articles.forEach((article) => {
        if (article.supplierArticleNo && article.supplier?.id) {
            recommendedArticlesIn.unshift({
                supplierArticleNo: article.supplierArticleNo,
                supplierId: article.supplier.id,
                isSelected: article.isSelected,
                productGroupId: article.productGroup.id,
            })
        }
    })

    // remove chain if we change the article that started CS. THIS NEEDS REFACTOR ASAP.
    if (!!refArticle && articles.some((a) => a.isSelected === true)) {
        const selectedArticle = articles.find((x) => x.isSelected === true)
        // salectedArticle! because typescript GOES DUMB
        if (!isSameArticle(refArticle, selectedArticle!)) {
            setCustomerAlsoBoughtArticlesChain(() => {
                localStorage.removeItem(`customerAlsoBought/${workTaskId}`)
                return []
            })
            setRecommendedArticlesChain(() => {
                localStorage.removeItem(`recommendedArticles/${workTaskId}`)
                return []
            })
            setCustomerAlsoBoughtProductGroupsState(() => {
                localStorage.removeItem(`customerAlsoBoughtProductGroups/${workTaskId}`)
                return []
            })
        }
    }

    // set article that has started the crossSelling isSelected to true
    if (!!refArticle && !articles.some((a) => a.isSelected === true)) {
        recommendedArticlesIn.unshift({
            supplierArticleNo: refArticle.supplierArticleNo,
            supplierId: refArticle.supplier.id,
            isSelected: refArticle.isSelected,
            productGroupId: refArticle.productGroup.id,
        })
    }

    recommendedArticlesIn = uniqBy(recommendedArticlesIn, (item) => `${item.supplierArticleNo}_${item.supplierId}`)

    if (!recommendedArticlesIn.length) {
        return undefined
    }

    return {
        modelId: vehicle?.tecDocTypeId ?? undefined,
        maxCount: 1,
        articles: recommendedArticlesIn,
    }
}
